import { atom } from "recoil";

export const schemaScriptState = atom({
  key: "schemaScriptState",
  default: "",
});
